export const ABO_ITEMS = 'ABO_ITEMS'
export const ABOUT = 'ABOUT'
export const ACCOUNTABILITY = 'ACCOUNTABILITY'
export const ACCOUNT_SUBSCRIPTIONS = 'ACCOUNT_SUBSCRIPTIONS'
export const ADD_TO_CART = 'ADD_TO_CART'
export const ADD_OFFER_TO_CART = 'ADD_OFFER_TO_CART'
export const AGB = 'AGB'
export const CART = 'CART'
export const CHECKOUT_ADDRESS_FORMAT = 'CHECKOUT_ADDRESS_FORMAT'
export const CHECKOUT_FORMAT = 'CHECKOUT_FORMAT'
export const CHECKOUT_PAYMENT_FORMAT = 'CHECKOUT_PAYMENT_FORMAT'
export const CHECKOUT_SHIPPING_FORMAT = 'CHECKOUT_SHIPPING_FORMAT'
export const CHECKOUT_VERIFICATION_FORMAT = 'CHECKOUT_VERIFICATION_FORMAT'
export const CHECKOUT_REDIRECT_RETURN_FORMAT = 'CHECKOUT_REDIRECT_RETURN_FORMAT'
export const CLIMATE_NEUTRAL_SHIPPING = 'CLIMATE_NEUTRAL_SHIPPING'
export const CMS_BRANDS = 'CMS_BRANDS'
export const CONFIRMATION = 'CONFIRMATION'
export const CONTACT = 'CONTACT'
export const DELIVERY_TRACKING = 'DELIVERY_TRACKING'
export const FAQ = 'FAQ'
export const FAQ_RATING_GUIDELINES = 'FAQ_RATING_GUIDELINES'
export const FAQ_SEARCH = 'FAQ_SEARCH'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const FORWARD = 'FORWARD'
export const HOME_PAGE = 'HOME_PAGE'
export const IMPRINT = 'IMPRINT'
export const LEGAL_TEXT_FORMAT = 'LEGAL_TEXT_FORMAT'
export const LOGOUT = 'LOGOUT'
export const LOGIN_AND_REGISTER = 'LOGIN_AND_REGISTER'
export const LOGIN = 'LOGIN'
export const MYREDPOINTS = 'MYREDPOINTS'
export const NEW_CART = 'NEW_CART'
export const NEW_CHECKOUT = 'NEW_CHECKOUT'
export const NEW_LOGIN_AND_REGISTER = 'NEW_LOGIN_AND_REGISTER'
export const NEW_CHECKOUT_ADDRESS = 'NEW_CHECKOUT_ADDRESS'
export const NEW_LOGIN = 'NEW_LOGIN'
export const NEW_REGISTER = 'NEW_REGISTER'
export const NEWSLETTER = 'NEWSLETTER'
export const NEWSLETTER_UNSUBSCRIBE = 'NEWSLETTER_UNSUBSCRIBE'
export const ONLINE_DOCTOR_SERVICE = 'ONLINE_DOCTOR_SERVICE'
export const ORDER_RETURN_REQUEST = 'ORDER_RETURN_REQUEST'
export const ORDER_SHIPMENT_TRACKING = 'ORDER_SHIPMENT_TRACKING'
export const ORDERS_LIST = 'ORDERS_LIST'
export const ORDERS = 'ORDERS'
export const PREMIUM_DELIVERY = 'PREMIUM_DELIVERY'
export const PRIVACY_SECURITY_CREDIT_CHECK = 'PRIVACY_SECURITY_CREDIT_CHECK'
export const PRIVACY_SECURITY = 'PRIVACY_SECURITY'
export const PRODUCT_REVIEWS_OVERVIEW = 'PRODUCT_REVIEWS_OVERVIEW'
export const PRODUCTS_BASE = 'PRODUCTS_BASE'
export const RED_POINTS_PROMO_URL = 'RED_POINTS_PROMO_URL'
export const REDPOINTS = 'REDPOINTS'
export const REGISTER = 'REGISTER'
export const SEARCH = 'SEARCH'
export const TRANSITION = 'TRANSITION'
export const MESSAGE_THREAD = 'MESSAGE_THREAD'
export const MESSAGE_THREAD_LIST = 'MESSAGE_THREAD_LIST'
export const MESSAGE_DOWNLOAD_ATTACHMENT = 'MESSAGE_DOWNLOAD_ATTACHMENT'
export const USER_ACCOUNT = 'USER_ACCOUNT'
export const NEW_USER_ACCOUNT = 'NEW_USER_ACCOUNT'
export const NOTEPAD = 'NOTEPAD'
export const ADD_TO_NOTEPAD = 'ADD_TO_NOTEPAD'
export const RECIPE_BONUS = 'RECIPE_BONUS'
export const RECIPE_BONUS_MODAL = 'RECIPE_BONUS_MODAL'
export const MASK_CAMPAIGN = 'MASK_CAMPAIGN'
export const ODS_TO_CART = 'ODS_TO_CART'
